var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPvIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 18,
    viewBox: "0 0 24 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.4986 1.47584L16.9616 2.25231C17.0635 2.42303 17.0023 2.6419 16.8258 2.74003C16.6495 2.83807 16.4241 2.7791 16.3225 2.60869L15.8594 1.83228C15.7576 1.66168 15.8188 1.44262 15.9953 1.3445C16.1714 1.2465 16.3969 1.30562 16.4986 1.47584ZM14.5448 3.10479L15.3469 3.55305C15.5229 3.65137 15.5838 3.86973 15.4826 4.04026C15.3812 4.21111 15.155 4.27029 14.9787 4.17179L14.1766 3.72352C14.0007 3.62521 13.9397 3.40684 14.0409 3.23631C14.1423 3.06553 14.3685 3.00635 14.5448 3.10479ZM23.149 3.72346L22.3469 4.17179C22.1705 4.27029 21.9444 4.2111 21.843 4.04026C21.7418 3.86973 21.8028 3.65136 21.9787 3.55305L22.7808 3.10479C22.9572 3.00622 23.1833 3.06547 23.2847 3.23631C23.3859 3.40684 23.3249 3.62521 23.149 3.72346ZM21.4662 1.83228L21.0031 2.60869C20.9016 2.77897 20.676 2.83802 20.4998 2.74003C20.3234 2.64196 20.2622 2.42291 20.3639 2.25231L20.827 1.47584C20.9286 1.30562 21.1542 1.24651 21.3304 1.3445C21.5068 1.44262 21.568 1.66168 21.4662 1.83228ZM19.0324 1.0098V1.90639C19.0324 2.10383 18.8668 2.26409 18.6628 2.26409C18.4587 2.26409 18.2932 2.10383 18.2932 1.90639V1.0098C18.2932 0.812296 18.4587 0.6521 18.6628 0.6521C18.8668 0.6521 19.0324 0.812296 19.0324 1.0098ZM20.827 10.1617L20.3639 9.38533C20.2623 9.2148 20.3225 8.99593 20.4985 8.89724C20.6747 8.79849 20.9013 8.85691 21.0031 9.02763L21.4662 9.80404C21.5679 9.97451 21.5077 10.1934 21.3316 10.2921C21.1555 10.3909 20.9289 10.3325 20.827 10.1617ZM22.7808 8.53217L21.9787 8.0839C21.8028 7.98558 21.7418 7.76722 21.843 7.59669C21.9444 7.42584 22.1705 7.3666 22.3469 7.46517L23.149 7.91343C23.3249 8.01174 23.3859 8.2301 23.2847 8.4007C23.1833 8.57155 22.9572 8.63072 22.7808 8.53217ZM23.6305 6.17621H22.7042C22.5003 6.17621 22.3348 6.01595 22.3348 5.81844C22.3348 5.621 22.5003 5.46074 22.7042 5.46074H23.6305C23.8345 5.46074 24 5.621 24 5.81844C24 6.01595 23.8345 6.17621 23.6305 6.17621Z",
    fill: "#828282"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.12916 6.06445H3.64584L2.96721 8.16467H5.6747L6.12916 6.06445Z",
    fill: "#828282"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.53464 6.06445L6.08023 8.16467H8.95821L9.12468 6.06445H6.53464Z",
    fill: "#828282"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.5233 6.06445L9.35683 8.16467H12.7506L12.5841 6.06445H9.5233Z",
    fill: "#828282"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.9827 6.06445L13.1492 8.16467H16.0272L15.5728 6.06445H15.2446H12.9827Z",
    fill: "#828282"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9783 6.06445L16.4327 8.16467H19.1401L18.4616 6.06445H15.9783Z",
    fill: "#828282"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.4497 5.67933H18.6075C18.7008 5.67933 18.7792 5.74166 18.8006 5.82567C19.1191 6.81131 19.4469 7.8258 19.74 8.73285C20.3111 8.52092 20.8027 8.15326 21.1591 7.68369C21.5439 7.17663 21.7713 6.55021 21.7713 5.87193C21.7713 5.02619 21.4172 4.26049 20.8446 3.70629C20.2721 3.15209 19.4811 2.80933 18.6075 2.80933C17.7338 2.80933 16.9427 3.15209 16.3702 3.70629C15.8415 4.21814 15.4989 4.91029 15.4497 5.67933Z",
    fill: "#828282"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.0612 14.1101H17.7191L18.4198 17.3478H22.1074L21.0612 14.1101Z",
    fill: "#828282"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.6359 13.7248H20.9368L20.1399 11.2588H17.1022L17.6359 13.7248Z",
    fill: "#828282"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.2303 13.7248L16.6967 11.2588H13.3944L13.5899 13.7248H17.2303Z",
    fill: "#828282"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.3136 14.1101H13.6205L13.8771 17.3478H18.0142L17.3136 14.1101Z",
    fill: "#828282"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.4785 17.3478L13.2219 14.1101H8.88555L8.62891 17.3478H11.0537H13.4785Z",
    fill: "#828282"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.23027 17.3478L8.48691 14.1101H4.79378L4.09317 17.3478H8.23027Z",
    fill: "#828282"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.68767 17.3478L4.38827 14.1101H1.04617L0 17.3478H3.68767Z",
    fill: "#828282"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.17067 13.7248H4.4716L5.00522 11.2588H1.9675L1.17067 13.7248Z",
    fill: "#828282"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.09198 10.8736H5.08855L5.59133 8.55005H2.84274L2.09198 10.8736Z",
    fill: "#828282"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.99684 8.55005L5.49406 10.8736H8.74347L8.92765 8.55005H5.99684Z",
    fill: "#828282"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.32622 8.55005L9.14211 10.8736H12.9653L12.7811 8.55005H9.32622Z",
    fill: "#828282"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.1797 8.55005L13.3639 10.8736H16.6133L16.1105 8.55005H13.1797Z",
    fill: "#828282"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.5161 8.55005L17.0189 10.8736H20.0155L19.2646 8.55005H16.5161Z",
    fill: "#828282"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.1913 13.7248L12.9958 11.2588H9.11157L8.91606 13.7248H13.1913Z",
    fill: "#828282"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.51745 13.7248L8.71296 11.2588H5.41075L4.87712 13.7248H8.51745Z",
    fill: "#828282"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPvIcon);
export default __webpack_public_path__ + "static/media/pv-icon.b8564e496ff467c0b401f7515d92d0b5.svg";
export { ForwardRef as ReactComponent };